/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CommentRectTextIcon20Solid = forwardRef('CommentRectTextIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3v1.955a1 1 0 0 0 1.614.79L10.143 15H15a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm.25 7.75A.75.75 0 0 1 6 9h5.5a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75ZM6 6a.75.75 0 0 0 0 1.5h8A.75.75 0 0 0 14 6H6Z" })));
});
